export default __webpack_public_path__ + "static/media/blog-g-2.7b7464ea.png";